import { combineReducers } from 'redux'
import { firebaseReducer } from 'react-redux-firebase'
import { authentication } from './authentication.reducer'
import { home } from './home.reducer'
import { entityReducer } from './entity.reducer'
import { filterReducer } from './filter.reducer'
import { editboardReducer } from './editboard.reducer'
import { dialogReducer, DialogState } from './dialog.reducer'
import { uiReducer, UIState } from './ui.reducer'
import { projectReducer } from './project.reducer'
import { alert } from './alert.reducer'
import { phasePlanReducer, PhasePlanState } from './phaseplan.reducer'
import { lookaheadReducer, LookaheadState } from './lookahead.reducer'

import { RouterState, connectRouter } from 'connected-react-router';

export const rootReducer = (history: History) =>	
combineReducers({
    alert,
    authentication,
    entityReducer,
    editboardReducer,
    dialogReducer,
    projectReducer,
    phasePlanReducer,
    lookaheadReducer,
    firebase: firebaseReducer,
    taskFilter: filterReducer,
    uiReducer: uiReducer,
    homeView: home,
    router: connectRouter(history)
})

export interface RootState { 
    router: RouterState;
    phasePlanState: PhasePlanState;
    dialogState: DialogState;
    uiState: UIState;
    lookaheadState: LookaheadState;
}
  



// WEBPACK FOOTER //
// ./src/modules/index.ts